import request from '@/utils/zsm-requets'
const role = '/role/api/role/'

/**
 * 添加授权
 * @param authAvatar 授权用户头像,
 *  @param authFrontId 授权用户frontId, 
 *  @param authNick   授权用户昵称 
 *  @param authOpenId 授权用户openid,
 *  @param powerApply:{
 *  @param applyGoodCover: 课程封面
 *  @param applyGoodId: 课程id
 *  @param applyGoodTitle:课程标题
 *  @param authMobile:授权用户手机号
 * }
 * @returns {*}
 */
export function savePower(params) {
  return request({
    url: role + 'power/savePower',
    method: 'post',
    params,
    base: 'douyin'
  })
}

/**
 * 粉丝群重新绑定
 *  @param id 账号主键ID
 * @returns {*}
 */
export function anewSavePower(params) {
  return request({
    url: role + 'power/anewSavePower',
    method: 'post',
    params,
    base: 'douyin'
  })
}





/**
 * 短视频绑定申请
 * @param id 键值id 
 * @returns 
 */
export function enableMountVideoScope(params) {
  return request({
    url: role + 'power/enableMountVideoScope',
    method: 'post',
    params,
    base: 'douyin'
  })
}

/**
 * 短视频绑定申请
 * @param id 键值id 
 * @returns 
 */
export function enableMountLiveScope(params) {
  return request({
    url: role + 'power/enableMountLiveScope',
    method: 'post',
    params,
    base: 'douyin'
  })
}

/**
 * 获取绑定数
 * @param roleEntityId 角色id
 * @returns 
 */
export function queryBindCount(params) {
  return request({
    url: role + 'power/queryBindCount',
    method: 'post',
    params,
    base: 'douyin'
  })
}

/**
 * 批量添加授权
 * @param authAvatar 授权用户头像,
 *  @param authFrontId 授权用户frontId, 
 *  @param authNick   授权用户昵称 
 *  @param authOpenId 授权用户openid,
 *  @param powerApply:{
 *  "applyGoodCover": 课程封面
 *  "applyGoodId": 课程id
 *  "applyGoodTitle":课程标题
 *  "authMobile":授权用户手机号
 * }
 * @returns {*}
 */
export function savePowerBath(data) {
  return request({
    url: role + 'power/savePowerBath',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data,
    base: 'douyin'
  })
}



/**
 * 解除授权
 * @param id 键值id
 * @returns {*}
 */
export function unbindAccount(params) {
  return request({
    url: role + 'power/unbindAccount',
    method: 'get',
    params,
    base: 'douyin'
  })
}





/**
 * 查看授权数据
 * @param roleEntityId 角色ID
 * @returns {*}
 */
export function powerRoleListData(params) {
  return request({
    url: role + 'power/listData',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    },
    params,
    base: 'douyin'
  })
}

/**
 * 处理授权申请
 * @param powerApply.applyStatus 状态
 * @param id 键值id
 * @returns {*}
 */
export function dealPowerApply(params) {
  return request({
    url: role + 'power/dealPowerApply',
    method: 'get',
    params,
    base: 'douyin'
  })
}



/**
 * 查询角色列表
 * @param mobile 讲师手机号
 * @returns {*}
 */
export function roleListData(params) {
  return request({
    url: role + 'listData',
    method: 'get',
    params,
    base: 'douyin'
  })
}

/**
 * 查询角色列表
 * @param id id
 * @returns {*}
 */
export function getRole(id) {
  return request({
    url: role + 'get',
    method: 'get',
    params: { id },
    base: 'douyin'
  })
}

/**
 * 查询单个资质
 * @param id id
 * @returns {*}
 */
export function getQualificationRole(id) {
  return request({
    url: role + 'getQualification',
    method: 'get',
    params: { id },
    base: 'douyin'
  })
}

/**
 * 老师/机构 入驻
 * @param params  对象
 * @returns {*}
 */
export function roleEnter(data) {
  return request({
    base: 'douyin',
    headers: {
      'Content-Type': 'application/json'
    },
    url: role + 'enter',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 修改基本信息
 * @param params  对象
 * @returns {*}
 */

export function saveBasicInfoRole(data) {
  return request({
    base: 'douyin',
    headers: {
      'Content-Type': 'application/json'
    },
    url: role + 'saveBasicInfo',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}
/**
 * 保存老师类目
 * @param params  对象
 * @returns {*}
 */
export function saveIndividualClassInfo(data) {
  return request({
    base: 'douyin',
    headers: {
      'Content-Type': 'application/json'
    },
    url: role + 'saveIndividualClassInfo',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 保存机构类目
 * @param params  对象
 * @returns {*}
 */
export function saveInstitutionClassInfo(data) {
  return request({
    base: 'douyin',
    headers: {
      'Content-Type': 'application/json'
    },
    url: role + 'saveInstitutionClassInfo',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}


/**
 * 添加授权函
 * @param params  对象
 * @returns {*}
 */
export function addAuthLetter(data) {
  return request({
    base: 'douyin',
    headers: {
      'Content-Type': 'application/json'
    },
    url: role + 'addAuthLetter',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}



